import { render } from "./SellerManage.vue?vue&type=template&id=4e5e5428&scoped=true"
import script from "./SellerManage.vue?vue&type=script&lang=js"
export * from "./SellerManage.vue?vue&type=script&lang=js"

import "./SellerManage.vue?vue&type=style&index=0&id=4e5e5428&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5e5428"]])

export default __exports__